module.exports = __webpack_public_path__ + "static/img/saimenInstallForWin_pic3.3373b4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForWin/saimenInstallForWin_pic3.png
// module id = 586
// module chunks = 1